import { ChainId } from "@layerzerolabs/lz-sdk";
import { Token } from "@layerzerolabs/x-trader-joe-bridge";

const tokens = [
  // @layerzerolabs/solidity-examples/contracts/token/oft/v2/fee/OFTWithFee.sol
  // remoteOFT (bridged version of the original erc20 on destination chain)
  // For deployment how-to, refer the file "solidity-examples\_deployment\ethereum-bsc-mainnet.txt"
  new Token(
    ChainId.BSC, // destination chain
    "0xd9483EA7214FCfd89B4Fb8f513B544920E315A52",
    18,
    "AVA"
  ),

  // Other destination chains can be added here
  // @layerzerolabs/solidity-examples/contracts/token/oft/v2/fee/OFTWithFee.sol
  // remoteOFT (bridged version of the original erc20 on destination chain)
  // For deployment how-to, refer the file "solidity-examples\_deployment\ethereum-bsc-mainnet.txt"
  // new Token(
  //   ChainId.ARBITRUM_GOERLI, // destination chain
  //   "0x???",
  //   18,
  //   "AVA"
  // ),
  /////////////////////////////////////////////

  // Original erc20 token
  new Token(
    ChainId.ETHEREUM, // source chain
    "0xa6C0c097741D55ECd9a3A7DeF3A8253fD022ceB9",
    18,
    "AVA"
  ),
];

const proxy = [
  {
    // @layerzerolabs/solidity-examples/contracts/token/oft/v2/fee/ProxyOFTWithFee.sol
    // localOFT (proxy version of the original erc20 on source chain)
    // For deployment how-to, refer the file "solidity-examples\_deployment\ethereum-bsc-mainnet.txt"
    chainId: ChainId.ETHEREUM,
    address: "0xd9483EA7214FCfd89B4Fb8f513B544920E315A52",
  },
];

export const tokens_mainnet = { tokens, proxy };
